// Cache local de turmas/instituições/usuários carregados do backend.
// Mantém compat com helpers legados de `utils/storageData.js`.

import { listarTurmas } from "../api/turmas";
import { listarInstituicoes } from "../api/instituicoes";
import { listarUsuarios } from "../api/usuarios";

let _turmas = [];
let _instituicoes = [];
let _usuarios = [];

function notificar() {
  window.dispatchEvent(new Event("app:data-changed"));
}

export function getTurmasCache() {
  return [..._turmas];
}

export function getInstituicoesCache() {
  return [..._instituicoes];
}

export function getUsuariosCache() {
  return [..._usuarios];
}

export async function carregarInstituicoes() {
  try {
    _instituicoes = (await listarInstituicoes()) || [];
  } catch {
    _instituicoes = [];
  }
  notificar();
  return _instituicoes;
}

export async function carregarTurmas(instituicaoId) {
  try {
    _turmas = (await listarTurmas(instituicaoId)) || [];
  } catch {
    _turmas = [];
  }
  notificar();
  return _turmas;
}

export async function carregarUsuarios(instituicaoId) {
  try {
    _usuarios = (await listarUsuarios(instituicaoId)) || [];
  } catch {
    _usuarios = [];
  }
  notificar();
  return _usuarios;
}

export async function hidratarTudo({ instituicaoId } = {}) {
  await Promise.allSettled([
    carregarInstituicoes(),
    instituicaoId ? carregarTurmas(instituicaoId) : carregarTurmas(),
    instituicaoId ? carregarUsuarios(instituicaoId) : Promise.resolve(),
  ]);
}

export function limparCaches() {
  _turmas = [];
  _instituicoes = [];
  _usuarios = [];
  notificar();
}
